<template>
    <div>
        <div>
            <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'需求管理'},{title:'新增信息获取'}]"/>
            <div class="h-content">
                <div class="h-row h-mrt0">
                    <div class="h-rowIn">
                        <div class="h-rowBox">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">
                                        新增需求
                                    </div>
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>需求信息</h1>
                                    </div>
                                    <div class="h-pieceCon2" style="padding:0">
                                        <div class="h-formLine create">
                                            <el-form :model="dd" label-position="right" ref="dd" :inline="true"
                                                     :rules="rules"
                                                     class="demo-ruleForm h-formbLine h-formbLine1">
                                                <el-form-item label="客户类型" class="h-elformWrap-2" prop="euType">
                                                    <el-select v-model="dd.euType" :v="dd.euType" placeholder="请选择"
                                                               @change="customerType">
                                                        <el-option v-for="(item) in options2"
                                                                   :key="item.code"
                                                                   :label="item.name"
                                                                   :value="item.code"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="客户全称" class="h-elformWrap-2" prop="euName">
                                                    <el-select v-model="dd.euName" :v="dd.euName" filterable remote placeholder="请输入"
                                                               :remote-method="showFormList" @change="showForm">
                                                        <el-option v-for="(item) in EuName"
                                                                   :key="item.id"
                                                                   :label="item.userName"
                                                                   :value="item.userName">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode"
                                                              v-if="customer.areaCode">
                                                    <el-input v-model="customer.areaCode" :v="customer.areaCode"
                                                              placeholder="自带出" readonly></el-input>
                                                </el-form-item>
                                                <el-form-item label="渠道" class="h-elformWrap-2" prop="channelCode"
                                                              v-if="customer.channelCode">
                                                    <el-input v-model="customer.channelCode"
                                                              :v="customer.channelCode" placeholder="自带出"
                                                              readonly></el-input>
                                                </el-form-item>
                                                <el-form-item label="部门/科室" class="h-elformWrap-2" prop="department">
                                                    <el-input v-model="dd.department"
                                                              :v="dd.department" placeholder="请输入"></el-input>
                                                </el-form-item>
                                                <el-form-item label="联系人" class="h-elformWrap-2" prop="contactuserName">
                                                    <el-input v-model="dd.contactuserName"
                                                              :v="dd.contactuserName"
                                                              placeholder="请输入"></el-input>
                                                </el-form-item>
                                                <el-form-item label="联系方式" class="h-elformWrap-2" prop="telephone">
                                                    <el-input v-model="dd.telephone"
                                                              :v="dd.telephone" placeholder="请输入"
                                                              oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                                                </el-form-item>
                                                <el-form-item label="需求类型" class="h-elformWrap-2">
                                                    <el-input value="信息获取"></el-input>
                                                </el-form-item>
                                                <el-form-item label="产品大类" class="h-elformWrap-2" prop="detail.proModel">
                                                    <el-select v-model="dd.detail.proCode" placeholder="请选择"
                                                               @change="showproModel(dd.detail.proCode)">
                                                        <el-option v-for="(item,index) in LevelName"
                                                                   :key="index"
                                                                   :label="item.levelname"
                                                                   :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="产品型号" class="h-elformWrap-2" prop="detail.proModel">
                                                    <el-select v-model="dd.detail.proModel"
                                                               placeholder="请选择">
                                                        <el-option v-for="(item,index) in ProModel"
                                                                   :key="index"
                                                                   :label="item.levelname"
                                                                   :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="需求数量" class="h-elformWrap-2" prop="detail.proNumber">
                                                    <el-input v-model="dd.detail.proNumber" :v="dd.detail.proNumber"
                                                              placeholder="请输入正整数" maxlength="10"
                                                              oninput="value=value.replace(/[^\d]/g, '')" @change="totalprice"></el-input>
                                                </el-form-item>
                                                <el-form-item label=产品单价 class="h-elformWrap-2" prop="detail.proPrice">
                                                    <el-input v-model="dd.detail.proPrice"
                                                              placeholder="请输入正整数" maxlength="8" @change="totalprice"></el-input>
                                                </el-form-item>
                                                <el-form-item label=产品总额 class="h-elformWrap-2" prop="proTotalAmount">
                                                    <el-input v-model="dd.detail.proTotalAmount" :v="dd.detail.proTotalAmount"
                                                              readonly></el-input>
                                                </el-form-item>
                                                <el-form-item label="需求说明" class="h-elformWrap-1" prop="content">
                                                    <el-input v-model="dd.content" :v="dd.content" maxlength="70"
                                                              placeholder="请输入"></el-input>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-txtCenter h-mrt60">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="backL">返回</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="zanCun">暂存
                    </el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="savedd">确认提交</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                f:{
                    userName:null,
                },
                //用户列表
                optionsCustomer: [],
                //经销商列表
                optionsAgent: [],
                //用户类型 用户2 客户1
                options2: [],
                LevelName: [],
                ProModel: [],
                EuName: [],
                //带线表单
                dd: {
                    userName: null,
                    euCode: null,
                    euName: null,
                    euType: null,
                    demandType: 2,
                    areaCode: null,
                    channelCode: null,
                    department: null,
                    contactuserName: null,
                    telephone: null,
                    content: null,
                    levelname: null,
                    detail: {
                        proCode: '',
                        proModel: '',
                        proNumber: '',
                        proPrice: '',
                        proTotalAmount: '',
                    },
                },
                customer: {
                    areaCode: null,
                    channelCode: null,
                },
                rules: {
                    euType: [{required: true, message: '请选择客户类型', trigger: 'blur'}],
                    euName: [{required: true, message: '请选择客户全称', trigger: 'blur'}],
                    department: [{required: true, message: '请填写部门/科室', trigger: 'blur'}],
                    contactuserName: [{required: true, message: '请填写联系人', trigger: 'blur'}],
                    telephone: [{required: true, message: '请填写联系电话', trigger: 'blur'}],
                    'detail.proCode': [{required: true, message: '请选择产品大类', trigger: 'blur'}],
                    'detail.proModel': [{required: true, message: '请选择产品型号', trigger: 'blur'}],
                    'detail.proNumber': [{required: true, message: '请填写需求数量', trigger: 'blur'}],
                    'detail.proPrice': [
                        {required: true, message: '请填写产品单价', trigger: 'blur'},
                        { validator: (rule, value, callback) => {
                                if (/^\d+.\d+$/.test(value) == false) {
                                    callback(new Error("只能写浮点数"));
                                } else {
                                    callback();
                                }
                            },trigger: 'blur'
                        }

                        ],
                    content: [{required: true, message: '请填写需求说明', trigger: 'blur'}],
                }
            }
        },
        created() {
            this.options2 = this.$store.getters.dicts["userCareType"];
            this.query();
           // this.customerOptions();
          //  this.agentOptions();
            this.showLevelName();
            this.showproModel();
        },
        methods: {
            totalprice(){
                if(this.dd.detail.proNumber!=null && this.dd.detail.proPrice!=null){
                    this.dd.detail.proTotalAmount = this.dd.detail.proNumber * this.dd.detail.proPrice;
                }
            },
            customerType() {
                this.dd.euName = null;
                this.customer.channelCode = null;
                this.dd.contactuserName = null;
                this.dd.department = null;
                this.dd.telephone = null;
                this.customer.areaCode = null;
                this.EuName=null;
            },
            // customerOptions() {
            //     //查询用户信息
            //     ss.UserCare.customerOption().then(rd => {
            //         this.optionsCustomer = rd;
            //     })
            // },
            // agentOptions() {
            //     //查询经销商客户信息
            //     ss.UserCare.agentOption().then(rd => {
            //         this.optionsAgent = rd;
            //     })
            // },
            //产品大类
            showLevelName() {
                ss.UserDemand.showLevelName().then(rd => {
                    this.LevelName = rd;
                })
            },
            showproModel(value) {
                this.dd.detail.proModel = '';
                ss.UserDemand.showproModel(value).then(rd => {
                    this.ProModel = rd;
                })
            },
            //通过用户名带出详细信息
            showFormList(value) {
                this.f.userName = value;
                if (this.dd.euType == 1) {
                    ss.UserCare.agentOption(this.f).then(rd => {
                        this.EuName = rd;
                    })
                } else if (this.dd.euType == 2) {
                    ss.UserCare.customerOption(this.f).then(rd => {
                        this.EuName = rd;
                    })
                }
            },
            showForm() {
                for (var i = 0; i < this.EuName.length; i++) {
                    if (this.dd.euName == this.EuName[i].userName) {
                        this.dd.euCode = this.EuName[i].userCode;
                        this.dd.areaCode = this.EuName[i].areaCode;
                        this.dd.channelCode = this.EuName[i].channelCode;
                        this.customer.areaCode = this.$getDictName("YLRegion", this.EuName[i].areaCode);
                        this.customer.channelCode = this.$getDictName("sales_region", this.EuName[i].channelCode);
                        this.dd.contactuserName = this.EuName[i].contactuserName;
                        this.dd.department = this.EuName[i].department;
                        this.dd.telephone = this.EuName[i].telephone;
                    }
                }
            },
            query() {
                this.dd.id = this.$route.query.id;
                if (this.dd.id != null) {
                    ss.UserDemand.demandDetail2(this.dd.id).then(rd => {
                        this.dd = rd;
                        this.dd.euType = this.$getDictName("userCareType", rd.euType);
                        this.customer.areaCode = this.$getDictName("YLRegion", rd.customer.areaCode);
                        this.customer.channelCode = this.$getDictName("sales_region", rd.customer.channelCode);
                    });
                }
            },
            zanCun() {
                if (this.dd.euType == null || this.dd.euName == null) {
                    this.$msg.msge("请先选择客户类型和客户全称！");
                } else {
                    if (this.dd.euType == "客户") {
                        this.dd.euType = 1;
                    } else if (this.dd.euType == "用户") {
                        this.dd.euType = 2;
                    }
                    ss.UserDemand.zanCun2(this.dd).then(rd => {
                        this.$msg.msgs("暂存成功");
                        this.$router.go(-1);
                    })
                }
            },
            savedd() {
                var subflag = false;
                this.$refs['dd'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    this.$msg.confirm("确认提交该信息获取?", () => {
                        if (this.dd.euType == "客户") {
                            this.dd.euType = 1;
                        } else if (this.dd.euType == "用户") {
                            this.dd.euType = 2;
                        }
                        ss.UserDemand.savedd(this.dd).then(rd => {
                            this.$msg.msgs("操作成功");
                            this.$router.go(-1);

                        });
                    });
                }
            },
            backL() {
                this.$router.go(-1);
            }
        }
    }
</script>
<style>
    .create .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .create .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .create .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .create .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .create .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .create .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }
</style>
